import { render, staticRenderFns } from "./TransferInventory.vue?vue&type=template&id=4b0688aa&scoped=true"
import script from "./TransferInventory.vue?vue&type=script&lang=js"
export * from "./TransferInventory.vue?vue&type=script&lang=js"
import style0 from "./TransferInventory.vue?vue&type=style&index=0&id=4b0688aa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0688aa",
  null
  
)

export default component.exports